import React from "react";
import { useTranslation } from "react-i18next";
import MainButton from "../../components/button/MainButton";
import MainInput from "../../components/input/MainInput";
import { HTTP_CODES } from "../../config/constants";
import ToastService from "../../services/toastService";
import UserService from "../../services/userService";
import { Footer } from "../../components/footer/Footer";


import logo from '../../assets/img/logo.png';
import loginBg from '../../assets/img/login_background.jpg';

const LoginPage = () => {
  const { t } = useTranslation();
  const { login } = UserService();
  const { showErrorToast } = ToastService();

  const initialUserData = {
    email: '',
    password: '',
    rememberMe: false
  };

  const [userData, setUserData] = React.useState(initialUserData);
  const initialErrors = { authError: false };
  const [errors, setErrors] = React.useState(initialErrors);
  const [isLoading, setIsLoading] = React.useState(false);

  const loginHandler = () => {
    setIsLoading(true);
    login(userData).catch(err => {
          if(err?.response?.status === HTTP_CODES.UNAUTHORIZED) setErrors((prevState) => ({...prevState, authError: true}))
          else showErrorToast(err?.response?.data?.message || t('ERROR.UNEXPECTED_ERROR'))
        }).finally(() => {
          setIsLoading(false);
        })
      }

  const clearErrors = () => {
      setErrors(initialErrors)
    }

  return (
    <>
        <div className="flex flex-col h-screen w-full overflow-hidden bg-white font-sans">
          <div className="flex-1 flex w-full relative overflow-hidden">

              <div className="w-full xl:w-1/2 flex flex-col h-full bg-white relative overflow-y-auto">

                <div className="pt-7 pl-12">
                  <img src={logo} className="h-5 w-auto object-contain" alt="Logo" />
                </div>

                <div className="flex-1 flex flex-col justify-center px-6 sm:px-12 lg:px-24 py-10">
                  <h1 className="text-3xl font-bold text-darkGray mb-2">
                    {t('LOGIN.WELCOME_BACK') }
                  </h1>
                  <p className="text-sm text-mediumGray mb-8">
                    {t('LOGIN.WELCOME_SUBTITLE')}
                  </p>

                  <div className="flex flex-col gap-5 mb-6">
                    <MainInput
                      value={userData.email}
                      fieldName={t('FORM_FIELDS.EMAIL')}
                      placeholder={t('FORM_FIELDS.EMAIL_PLACEHOLDER')}
                      onChange={(email) => {
                        clearErrors();
                        setUserData((prev) => ({...prev, email:email}));
                      }}
                    />

                    <MainInput
                      value={userData.password}
                      type='password'
                      fieldName={t('FORM_FIELDS.PWD')}
                      placeholder={t('FORM_FIELDS.PWD_PLACEHOLDER')}
                      onChange={(pwd) => {
                        clearErrors();
                        setUserData((prev) => ({...prev, password: pwd}));
                      }}
                      error={errors.authError}
                      errorMessage={t('ERROR.AUTH')}
                    />
                  </div>

                  <div className="flex justify-between items-center mb-8 text-xs text-mediumGray">
                    <label className="flex items-center cursor-pointer select-none gap-2">
                      <input
                        type="checkbox"
                        className="rounded border-mediumGray text-darGray focus:ring-darGray cursor-pointer"
                        checked={userData.rememberMe}
                        onChange={(e) => setUserData(prev => ({...prev, rememberMe: e.target.checked}))}
                      />
                      <span>{t('LOGIN.REMEMBER_ME')}</span>
                    </label>

                    <span className="font-bold cursor-pointer hover:underline">
                      {t('LOGIN.FORGOT_PASSWORD') }
                    </span>
                  </div>

                  <MainButton
                     variant="primary"
                     className="w-full"
                     disabled={isLoading || userData.email.length === 0 || userData.password.length === 0}
                     onClick={loginHandler}
                  >{t('LOGIN.LOGIN')}
                  </MainButton>
                </div>
              </div>

              <div className="hidden xl:block w-1/2 h-full relative">
                  <div
                      className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                      style={{ backgroundImage: `url(${loginBg})` }}
                  />
              </div>
          </div>
          <Footer />
        </div>
      </>
  );
};

export default LoginPage;